import { PROJECT_MEMBERSHIP_ROLES } from '../../core/constants';
import { EnumField, FieldProps, TextField, useFieldHelper } from 'framework/ui/field';

const AssignmentMembershipRoleField = ({ source = 'membershipRole', ...props }: FieldProps) => {
  const { getValue: getMembershipRole } = useFieldHelper({ source });

  return getMembershipRole() ? (
    <EnumField options={PROJECT_MEMBERSHIP_ROLES} source={source} {...props} />
  ) : (
    <TextField value="-" {...props} />
  );
};

export default AssignmentMembershipRoleField;
